export { default } from './SmsPreferences';
export type { Props, SmsPreferences } from './types';
